<xng-breadcrumb>
    <ng-container *xngBreadcrumbItem="let breadcrumb; let icon = info; let first = first">
        <mat-icon class="riege-icon md-20" *ngIf="icon">{{ icon }}</mat-icon>
        <ng-container>{{ breadcrumb }}</ng-container>
    </ng-container>
</xng-breadcrumb>
